// Copyright © 2017-2020  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <div>
  <v-layout row wrap v-for="(line, key, i) in model" :key="i">
    <v-flex xs6 sm3>
      {{ key }}
    </v-flex>
    <v-flex xs6 sm9>
      <span v-if="line.type==='array'">
        <span v-if="line.items.type">[{{ line.items.type }}]</span>
        <a @click="scrollMeTo(line.items.$ref)" v-else>[{{ replaceModelName(line.items.$ref) }}]</a>
      </span>
      <span v-else-if="line.type==='object'">
        <span>{{ line.description }}</span><br>
        <model :model="line.properties"></model>
      </span>
      <span v-else>
        <span v-if="line.type">{{line.type}}
          <span v-if="line.format" class="font-italic"> $({{line.format}})</span>
        </span>
        <a @click="scrollMeTo(line.$ref)" v-else>{{ replaceModelName(line.$ref) }}</a>
      </span>

    </v-flex>
  </v-layout>
  </div>
</template>

<script>
export default {
  name: 'model',
  props: {
    model: Object
  },

  methods: {
    replaceModelName: function (name) {
      var split = name.split('/')
      return 'Model: ' + split[split.length - 1]
    },

    scrollMeTo (refName) {
      // if (typeof refName === 'string') {
      //   var split = refName.split('/')
      //   var dest = split[split.length - 1]

      //   var element = this.$refs['model_' + dest]
      //   var top = element[0].offsetParent.offsetTop
      //   window.scrollTo(0, top)
      // } else {
      //   console.log('scroll error: ' + refName)
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Model.vue